import BaseModal from "components/modals/BaseModal";
import modalAuthTemplate from "templates/liveTV/_modalAuth.tpl";
import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import Router from 'aa/vue/Router';
import Store from 'aa/vue/stores/Store';
import SignIn from 'aa/vue/components/SignIn';
import SignUp from 'aa/vue/components/SignUp';
import AgeGate from 'aa/vue/components/AgeGate';
import ForgotPassword from 'aa/vue/components/ForgotPassword';
import LiveTVTrackingService from "services/LiveTVTrackingService";
import HttpService from "services/HttpService";
import localeBundlePlugin from 'plugins/localeBundle';
import { getBundleFromJSON } from 'services/LocalizationService';

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(localeBundlePlugin);

const store = Store();
const router = Router({ store });
const http = new HttpService();
const localeBundle = getBundleFromJSON();


export default class AuthModal extends BaseModal {

    constructor() {
        super(modalAuthTemplate());

        this.defaultAction = null;
        this.tracking = new LiveTVTrackingService();
    }

    setDefaultAction(action) {
        this.defaultAction = action;
    }

    show() {
        super.show();
        this.__initVueApp();
    }

    __initVueApp() {
        let parent = this;
        let serverData = JSON.parse(document.querySelector('#app-config').innerHTML);
        let action = this.defaultAction;

        http.regionBaseUrl = serverData.regionBaseUrl
        store.$http = http
        Vue.prototype.$http = http

        new Vue({
            router,
            store,
            props: {
                action: {
                    type: String,
                    default: action
                }
            },
            components: {
                SignIn,
                SignUp,
                ForgotPassword,
                AgeGate,
            },
            created() {
                store.commit('setToken', serverData.tk_trp)
                store.commit('setLocaleDictionary', localeBundle);
                this.updateTitleByModal(this.modal);
            },
            mounted() {
                const button = document.querySelector('.button__close');
                if (button) {
                    button.focus();
                }
            },
            data() {
                return {
                    modal: this.action,
                    serverData: serverData
                }
            },
            watch: {
                modal(newVal) {
                    this.updateTitleByModal(newVal);
                }
            },
            methods: {
                onForgotPasswordClicked() {
                    this.modal = 'forgot-password';
                },

                onSignUpClicked() {
                    this.modal = 'sign-up';
                    parent.tracking.trackSignUpModal();
                },

                onSignInClicked() {
                    this.modal = 'sign-in';
                    parent.tracking.trackSignInModal();
                },

                onSignInSuccess() {
                    window.location.assign(this.$store.getters["flow/destinationUrl"]);
                },

                onSignUpSuccess() {
                    window.location.assign(this.$store.getters["flow/destinationUrl"]);
                },

                onSignUpAgeGate() {
                    this.modal = 'age-gate'
                    parent.setDismissible(false)
                    parent.removeCloseButton()
                },

                onCancelForgotPassword() {
                    this.modal = 'sign-in';
                    parent.tracking.trackSignInModal();
                },

                updateTitleByModal(modal) {
                    let title = '';
                    if (modal === 'sign-in') {
                        title = 'Sign In';
                    } else if (modal === 'sign-up') {
                        title = 'Sign Up';
                    } else if (modal === 'forgot-password') {
                        title = 'Resetting password';
                    }

                    document.querySelector('.modal__title').innerHTML = title;
                }
            }
        }).$mount('#vue-app');
    }

}
